import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Header } from './Header';
import { VideoListing } from './VideoListing';
import { EmptyState } from '../../../../../../common/react/components/EmptyState';
import { navSelector } from '../../../../store/js/modules/video-hub/nav/selectors/nav-selector';
import { viewByMatchSelector } from '../../../../store/js/modules/video-hub/view-by-match/selectors';
import { getTranslation } from '../../../../../../common/react/utils/translations';

export const VideoListContainer = ({ defaultFilter, defaultFilterText }) => {
    const [activeId, setActiveId] = useState(0);
    let links = [
        {
            filter: 'ProgramCategory:Match Highlights',
            translation: 'label.match.highlights'
        },
        {
            filter: 'ProgramCategory:Mini-Matches',
            translation: 'label.match.mini.matches'
        },
        {
            filter: 'ProgramCategory:Match Replays',
            translation: 'label.match.fullReplays'
        },
        {
            filter: 'ProgramCategory:Press Conference',
            translation: 'label.match.press.conference'
        }
    ];

    // Adding the default filter to the links array if it's present.
    if (defaultFilterText && defaultFilter) {
        const newFilterItem = {
            filter: defaultFilter,
            translation: defaultFilterText
        };

        links.unshift(newFilterItem);
    }

    const matchID = useSelector(viewByMatchSelector)?.matchId;
    const roundNumber = useSelector(navSelector)?.round;
    const [videoData, setVideoData] = useState([]);

    const nav = useSelector(navSelector);
    const matchesData = useSelector(
        (state) =>
            PULSE.app.redux.selectors.matchList.item(
                state,
                nav.competition?.id,
                nav.season?.id,
                nav.round
            ) ?? []
    );
    const [matchData, setMatchData] = useState([]);

    const matchActiveIndex = useSelector(viewByMatchSelector)?.activeIndex;

    useEffect(() => {
        let tagSelected = links[activeId].filter;
        // If a round number and match id has been passed to the component the url query is updated.
        if (roundNumber && matchID && matchActiveIndex >= 0) {
            const url = PULSE.app.common.url.createContentPath('VIDEO', {
                pageSize: 10,
                referenceExpression: `AFL_COMPSEASON:${nav.season?.id} and AFL_ROUND:${nav.round} and AFL_MATCH:${matchID}`
            });
            fetch(url)
                .then((response) => {
                    if (response.ok) {
                        return response.json();
                    }
                })
                .then(function (data) {
                    setVideoData(data.content);
                })
                .catch((err) => {
                    console.error(err); // eslint-disable-line no-console
                    setVideoData();
                });
            const match = matchesData.find((obj) => obj.id === matchID);
            if (match) {
                setMatchData(match);
            }
        } else if (roundNumber) {
            // If only a round number has been passed to the component the url query is updated.
            const url = PULSE.app.common.url.createContentPath('VIDEO', {
                pageSize: 10,
                referenceExpression: `AFL_COMPSEASON:${nav.season?.id} and AFL_ROUND:${nav.round}`,
                tagNames: tagSelected
            });
            fetch(url)
                .then((response) => {
                    if (response.ok) {
                        return response.json();
                    }
                })
                .then(function (data) {
                    setVideoData(data.content);

                    // Hide filters if no videos have those tags
                    let tagsInUse = [];
                    for (let i = 0; i < data.content.length; i++) {
                        let item = data.content[i];
                        for (let a = 0; a < item.tags.length; a++) {
                            if (
                                item.tags[a].label.includes('ProgramCategory:')
                            ) {
                                tagsInUse.unshift(item.tags[a].label);
                            }
                        }
                    }
                    let uniqueTag = [...new Set(tagsInUse)];
                    for (let i = 0; i < uniqueTag.length; i++) {
                        Array.from(
                            document.querySelectorAll(
                                '.js-video-filter-item .video-list__filters-item'
                            )
                        ).forEach((element) => {
                            if (uniqueTag[i] === element.dataset.filterType) {
                                element.parentNode.classList.remove('u-hide');
                            }
                        });
                    }
                })
                .catch((err) => {
                    console.error(err); // eslint-disable-line no-console
                    setVideoData();
                });
        }
    }, [matchID, roundNumber, activeId, matchActiveIndex]);
    useEffect(() => {
        // Reseting filters back to the original state when rounds are updated.
        setActiveId(0);
    }, [roundNumber]);
    return (
        <div className="media-list media-list--video video-hub-video-listing">
            <div className="wrapper">
                <Header
                    className="widget-header"
                    roundNumber={roundNumber}
                    matchData={matchData}
                    matchID={matchID}
                    ActiveMatch={matchActiveIndex}
                />
                {matchActiveIndex < 0 && (
                    <ul className="video-list__filters video-hub-video-listing__filters js-video-filters">
                        {links.map((link, index) => (
                            <li
                                key={index}
                                className="video-hub-video-listing__list js-video-filter-item u-hide"
                            >
                                <button
                                    onClick={() => setActiveId(index)}
                                    role="button"
                                    className={
                                        activeId === index
                                            ? 'js-filter-option video-list__filters-item js-default-filter is-filter-selected'
                                            : 'js-filter-option video-list__filters-item js-default-filter'
                                    }
                                    data-filter-type={link.filter}
                                >
                                    {getTranslation(link.translation)
                                        ? getTranslation(link.translation)
                                        : defaultFilterText}
                                </button>
                            </li>
                        ))}
                    </ul>
                )}
                {!videoData ? (
                    <div className="key-stats-and-performance__empty-state">
                        <EmptyState />
                    </div>
                ) : (
                    <VideoListing videoData={videoData} />
                )}
            </div>
        </div>
    );
};

VideoListContainer.propTypes = {
    defaultFilter: PropTypes.string,
    defaultFilterText: PropTypes.string
};
